import { Button, Grid, Modal, Step, StepLabel, Stepper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { ProductAplication } from './productApplcation'
import { PatientProduct } from '../../modules/patient/models/relationship/PatientProduct'
import { PatientAplication } from './patientApplication'
import { File } from '../../modules/files/models/File'
import { SampleAplication } from './sampleApplication'
import { Address } from '../../modules/address/models/Address'
import { emptyAddressDTO, toModel } from '../../modules/address/models/AddressDTO'
import { getClient2RequestContainer } from 'container/client2request-modules'
import { Client2RequestService } from 'modules/client2Requests/services/Client2RequestService'
import { CLIENT2REQUEST_SERVICE_KEY } from 'modules/client2Requests'
import { getRequestContainer } from '../../container/request-modules'
import { RequestService } from '../../modules/request/services/RequestService'
import { REQUEST_SERVICE_KEY } from '../../modules/request'
import { Request } from '../../modules/request/models/Request'
import { LoadingSpinner } from '../../components/loading-spinner/LoadingSpinner'
import style from '../../components/loading-spinner/LoadingSpinner.module.css'
import { getAuthContainer } from '../../container/auth-modules'
import { AuthService } from '../../modules/auth/services/AuthService'
import { AUTH_SERVICE_KEY } from '../../modules/auth'
import {
  emptyPatientProductDTO,
  PatientProductDTO,
} from 'modules/patient/models/relationship/PatientProductDTO'
import { useNavigate } from 'react-router-dom'
import { URL_APPLICATIONS } from 'routes/routes-constants'
import { getSampleTypeContainer } from 'container/sampleType-modules'
import { SampleTypeService } from 'modules/sampleType/services/SampleTypeService'
import { SAMPLETYPE_SERVICE_KEY } from 'modules/sampleType'
import { Query, QueryParam } from 'common/api/Query'
import { FormType } from 'common/enums/Enums'
import { useSnackbar } from 'notistack'
import { Permission } from 'common/enums/Permissions'
import { ModalChangeClient } from './ModalChangeClient'

type DetailProps = {
  id?: string
  saveDraftAgain?: boolean
  setSaveDraftAgain: (b: boolean) => void
}

const steps = ['product', 'form', 'samples']
const client2RequestService = getClient2RequestContainer().get<Client2RequestService>(
  CLIENT2REQUEST_SERVICE_KEY
)
const requestService = getRequestContainer().get<RequestService>(REQUEST_SERVICE_KEY)
const authService = getAuthContainer().get<AuthService>(AUTH_SERVICE_KEY)
const clientRequestService = getClient2RequestContainer().get<Client2RequestService>(
  CLIENT2REQUEST_SERVICE_KEY
)
const sampleTypeService = getSampleTypeContainer().get<SampleTypeService>(SAMPLETYPE_SERVICE_KEY)

export const Edit = (props: DetailProps) => {
  const { t } = useTranslation()
  const [currentStep, setCurrentStep] = useState<number>(0)
  const increaseStep = () => setCurrentStep(currentStep + 1)
  const decreseStep = () => setCurrentStep(currentStep - 1)
  const [patientProducts, setPatientProducts] = useState<PatientProduct[]>([])
  const [files, setFiles] = useState<any[]>([])
  const [address, setAddress] = useState<Address>(toModel(emptyAddressDTO()))
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [request, setRequest] = useState<Request>()
  const loggedUser = authService.get()
  const { enqueueSnackbar } = useSnackbar()
  const [blindMatchingSelected, setBlindMatchingSelected] = useState<boolean>(false)
  const [panelSelections, setPanelSelections] = useState<string[]>(['full', 'full'])
  const [changeClientModalOpen, setChangeClientModalOpen] = useState<boolean>(false)
  const navigate = useNavigate()

  const updatePanelSelection = (value: string, index: number) => {
    const updated = [...panelSelections]
    updated[index] = value
    setPanelSelections(updated)
  }

  const handleIncreaseStep = () => {
    let completed = true
    
    patientProducts.forEach((p) => {
      if (p._product) {
        switch (Number(p._product.typeForm)) {
          case FormType.TypeFormCitogeneticaArray:
            p._patientCitogenetics.forEach((patient, i) => {
              if (i == 0) {
                if (
                  !patient._firstName ||
                  !patient._lastName ||
                  !patient._nhc ||
                  patient._sex == '0' ||
                  !patient._dob
                ) {
                  completed = false
                  enqueueSnackbar(
                    t('mustCompleteTheFields') +
                      t('firstName') +
                      ', ' +
                      t('lastName') +
                      ', ' +
                      t('sex') +
                      ', ' +
                      t('dob') +
                      ', ' +
                      t('nhc'),
                    {
                      variant: 'error',
                    }
                  )
                }
              }
            })
            break
          case FormType.TypeFormPGT:
            p._patientPGTs.forEach((patient, i) => {
              if (i == 0) {
                if (!patient._firstName || !patient._lastName || !patient._nhcOrDni) {
                  completed = false
                  enqueueSnackbar(t('mustCompleteTheFields') + t('firstName') + ', ' + t('nhc'), {
                    variant: 'error',
                  })
                }
              }
            })
            break
          case FormType.TypeFormOncology:
            p._patientOncology.forEach((patient, i) => {
              if (i == 0) {
                if (
                  !patient._firstName ||
                  !patient._lastName ||
                  patient._sex == '0' ||
                  !patient._dob ||
                  !patient._diagnosis
                ) {
                  completed = false
                  enqueueSnackbar(
                    t('mustCompleteTheFields') +
                      t('firstName') +
                      ', ' +
                      t('lastName') +
                      ', ' +
                      t('sex') +
                      ', ' +
                      t('dob') +
                      ', ' +
                      t('diagnosis'),
                    {
                      variant: 'error',
                    }
                  )
                }
              }
            })
            break
          case FormType.TypeFormMicroVEBioER:
            p._patientMicroVE.forEach((patient, i) => {
              if (i == 0) {
                if (!patient._firstName || !patient._lastName || !patient._nhc) {
                  completed = false
                  enqueueSnackbar(
                    t('mustCompleteTheFields') +
                      t('firstName') +
                      ', ' +
                      t('lastName') +
                      ', ' +
                      t('nhc'),
                    {
                      variant: 'error',
                    }
                  )
                }
              }
            })
            break
          case FormType.TypeFormNGS:
            p._patientNGS.forEach((patient, i) => {
              if (i == 0) {
                if (
                  !patient._firstName ||
                  !patient._lastName ||
                  !patient._nhc ||
                  patient._sex == '0' ||
                  !patient._dob
                ) {
                  completed = false
                  enqueueSnackbar(
                    t('mustCompleteTheFields') +
                      t('firstName') +
                      ', ' +
                      t('lastName') +
                      ', ' +
                      t('sex') +
                      ', ' +
                      t('dob') +
                      ', ' +
                      t('nhc'),
                    {
                      variant: 'error',
                    }
                  )
                }
              }
            })
            break
          default:
            break
        }
      } else if (p.product) {
        switch (Number(p.product.typeForm)) {
          case FormType.TypeFormCitogeneticaArray:
            p.patientCitogenetics.forEach((patient, i) => {
              if (i == 0) {
                if (
                  !patient._firstName ||
                  !patient._lastName ||
                  !patient._nhc ||
                  patient._sex == '0' ||
                  !patient._dob
                ) {
                  completed = false
                  enqueueSnackbar(
                    t('mustCompleteTheFields') +
                      t('firstName') +
                      ', ' +
                      t('lastName') +
                      ', ' +
                      t('sex') +
                      ', ' +
                      t('dob') +
                      ', ' +
                      t('nhc'),
                    {
                      variant: 'error',
                    }
                  )
                }
              }
            })
            break
          case FormType.TypeFormPGT:
            p.patientPGTs.forEach((patient, i) => {
              if (i == 0) {
                if (!patient._firstName || !patient._lastName || !patient._nhcOrDni) {
                  completed = false
                  enqueueSnackbar(t('mustCompleteTheFields') + t('firstName') + ', ' + t('nhc'), {
                    variant: 'error',
                  })
                }
              }
            })
            break
          case FormType.TypeFormOncology:
            p.patientOncology.forEach((patient, i) => {
              if (i == 0) {
                if (
                  !patient._firstName ||
                  !patient._lastName ||
                  patient._sex == '0' ||
                  !patient._dob ||
                  !patient._diagnosis
                ) {
                  completed = false
                  enqueueSnackbar(
                    t('mustCompleteTheFields') +
                      t('firstName') +
                      ', ' +
                      t('lastName') +
                      ', ' +
                      t('sex') +
                      ', ' +
                      t('dob') +
                      ', ' +
                      t('diagnosis'),
                    {
                      variant: 'error',
                    }
                  )
                }
              }
            })
            break
          case FormType.TypeFormMicroVEBioER:
            p.patientMicroVE.forEach((patient, i) => {
              if (i == 0) {
                if (!patient._firstName || !patient._lastName || !patient._nhc) {
                  completed = false
                  enqueueSnackbar(
                    t('mustCompleteTheFields') +
                      t('firstName') +
                      ', ' +
                      t('lastName') +
                      ', ' +
                      t('nhc'),
                    {
                      variant: 'error',
                    }
                  )
                }
              }
            })
            break
          case FormType.TypeFormNGS:
            p.patientNGS.forEach((patient, i) => {
              if (i == 0) {
                if (
                  !patient._firstName ||
                  !patient._lastName ||
                  !patient._nhc ||
                  patient._sex == '0' ||
                  !patient._dob
                ) {
                  completed = false
                  enqueueSnackbar(
                    t('mustCompleteTheFields') +
                      t('firstName') +
                      ', ' +
                      t('lastName') +
                      ', ' +
                      t('sex') +
                      ', ' +
                      t('dob') +
                      ', ' +
                      t('nhc'),
                    {
                      variant: 'error',
                    }
                  )
                }
              }
            })
            break
          default:
            break
        }
      }
    })

    completed && increaseStep()
  }

  const handleChangeFiles = (fs: File[]) => {
    setFiles(fs)
  }

  useEffect(() => {
    if (props.saveDraftAgain) {
      checkRequiredFields()
    }
  }, [props.saveDraftAgain])

  const checkRequiredFields = () => {
    let completed = true

    patientProducts.forEach((p) => {
      if (p._product) {
        switch (Number(p._product.typeForm)) {
          case FormType.TypeFormMicroVEBioER:
            p._patientMicroVE.forEach((patient, i) => {
              if (i == 0) {
                if (patient._sample?._question1) {
                  if (!patient._sample?._endDate) {
                    patient._sample._endDate = new Date()
                  }
                  if (
                    !patient._sample?._typeAntibioticTreatment ||
                    !patient._sample?._treatmentDuration ||
                    !patient._sample?._endDate
                  ) {
                    completed = false
                    enqueueSnackbar(
                      t('mustCompleteTheFields') +
                        t('typeAntibioticTreatment') +
                        ', ' +
                        t('treatmentDuration') +
                        ', ' +
                        t('endDate'),
                      {
                        variant: 'error',
                      }
                    )
                  }
                }

                if (i == 0) {
                  if (!patient._sample?._typeSample) {
                    completed = false
                    enqueueSnackbar(t('mustCompleteTheField') + t('typeSample'), {
                      variant: 'error',
                    })
                  }
                }

                if (patient._sample?._question2) {
                  if (!patient._sample?._reportDate) {
                    patient._sample._reportDate = new Date()
                  }
                  if (
                    !patient._sample?._reportDate ||
                    patient._sample?._result == '' ||
                    patient._sample?._followedTreatment == ''
                  ) {
                    completed = false
                    enqueueSnackbar(
                      t('mustCompleteTheFields') +
                        t('reportDate') +
                        ', ' +
                        t('result') +
                        ', ' +
                        t('followedTreatment'),
                      {
                        variant: 'error',
                      }
                    )
                  }
                }
              }
            })
            if (!patientProducts[0].language && !patientProducts[0]._language) {
              completed = false
              enqueueSnackbar(t('mustCompleteTheField') + t('language'), {
                variant: 'error',
              })
            }
            break

          case FormType.TypeFormPGT:
            p._patientPGTs.forEach((patient, i) => {
              if (i == 0) {
                if (!patient._sample?._typeSample) {
                  completed = false
                  enqueueSnackbar(t('mustCompleteTheField') + t('typeSample'), {
                    variant: 'error',
                  })
                }
              }
            })
            if (!patientProducts[0].language && !patientProducts[0]._language) {
              completed = false
              enqueueSnackbar(t('mustCompleteTheField') + t('language'), {
                variant: 'error',
              })
            }
            break

          case FormType.TypeFormOncology:
            p._patientOncology.forEach((patient, i) => {
              if (i == 0) {
                if (!patient._sample?._typeSample) {
                  completed = false
                  enqueueSnackbar(t('mustCompleteTheField') + t('typeSample'), {
                    variant: 'error',
                  })
                }
              }
            })
            if (!patientProducts[0].language && !patientProducts[0]._language) {
              completed = false
              enqueueSnackbar(t('mustCompleteTheField') + t('language'), {
                variant: 'error',
              })
            }
            break
          case FormType.TypeFormCitogeneticaArray:
            p._patientCitogenetics.forEach((patient, i) => {
              if (i == 0) {
                if (!patient._sample?._typeSample) {
                  completed = false
                  enqueueSnackbar(t('mustCompleteTheField') + t('typeSample'), {
                    variant: 'error',
                  })
                }
              }
            })
            if (!patientProducts[0].language && !patientProducts[0]._language) {
              completed = false
              enqueueSnackbar(t('mustCompleteTheField') + t('language'), {
                variant: 'error',
              })
            }
            break
          case FormType.TypeFormNGS:
            p._patientNGS.forEach((patient, i) => {
              if (i == 0) {
                if (!patient._sample?._typeSample) {
                  completed = false
                  enqueueSnackbar(t('mustCompleteTheField') + t('typeSample'), {
                    variant: 'error',
                  })
                }
              }
            })
            if (!patientProducts[0].language && !patientProducts[0]._language) {
              completed = false
              enqueueSnackbar(t('mustCompleteTheField') + t('language'), {
                variant: 'error',
              })
            }
            break
          case FormType.TypeFormNull:
            p._patientNulls.forEach((patient, i) => {
              if (i == 0) {
                if (!patient._sample?._type) {
                  completed = false
                  enqueueSnackbar(t('mustCompleteTheField') + t('typeSample'), {
                    variant: 'error',
                  })
                }
              }
            })
            if (!patientProducts[0].language && !patientProducts[0]._language) {
              completed = false
              enqueueSnackbar(t('mustCompleteTheField') + t('language'), {
                variant: 'error',
              })
            }
            break
          default:
            if (!patientProducts[0].language && !patientProducts[0]._language) {
              completed = false
              enqueueSnackbar(t('mustCompleteTheField') + t('language'), {
                variant: 'error',
              })
            }
            break
        }
      } else if (p.product) {
        switch (Number(p.product.typeForm)) {
          case FormType.TypeFormMicroVEBioER:
            p.patientMicroVE.forEach((patient, i) => {
              if (i == 0) {
                if (!patient._sample?._typeSample) {
                  completed = false
                  enqueueSnackbar(t('mustCompleteTheField') + t('typeSample'), {
                    variant: 'error',
                  })
                }

                if (patient._sample?._question1) {
                  if (
                    !patient._sample?._typeAntibioticTreatment ||
                    !patient._sample?._treatmentDuration ||
                    !patient._sample?._endDate
                  ) {
                    completed = false
                    enqueueSnackbar(
                      t('mustCompleteTheFields') +
                        t('typeAntibioticTreatment') +
                        ', ' +
                        t('treatmentDuration') +
                        ', ' +
                        t('endDate'),
                      {
                        variant: 'error',
                      }
                    )
                  }
                }

                if (patient._sample?._question2) {
                  if (
                    !patient._sample?._reportDate ||
                    !patient._sample?._result ||
                    !patient._sample?._followedTreatment
                  ) {
                    completed = false
                    enqueueSnackbar(
                      t('mustCompleteTheFields') +
                        t('reportDate') +
                        ', ' +
                        t('result') +
                        ', ' +
                        t('followedTreatment'),
                      {
                        variant: 'error',
                      }
                    )
                  }
                }
              }
            })

            if (!patientProducts[0].language && !patientProducts[0]._language) {
              completed = false
              enqueueSnackbar(t('mustCompleteTheField') + t('language'), {
                variant: 'error',
              })
            }
            break

          case FormType.TypeFormPGT:
            p.patientPGTs.forEach((patient, i) => {
              if (i == 0) {
                if (!patient._sample?._typeSample) {
                  completed = false
                  enqueueSnackbar(t('mustCompleteTheField') + t('typeSample'), {
                    variant: 'error',
                  })
                }
              }
            })
            if (!patientProducts[0].language && !patientProducts[0]._language) {
              completed = false
              enqueueSnackbar(t('mustCompleteTheField') + t('language'), {
                variant: 'error',
              })
            }
            break

          case FormType.TypeFormOncology:
            p.patientOncology.forEach((patient, i) => {
              if (i == 0) {
                if (!patient._sample?._typeSample) {
                  completed = false
                  enqueueSnackbar(t('mustCompleteTheField') + t('typeSample'), {
                    variant: 'error',
                  })
                }
              }
            })
            if (!patientProducts[0].language && !patientProducts[0]._language) {
              completed = false
              enqueueSnackbar(t('mustCompleteTheField') + t('language'), {
                variant: 'error',
              })
            }
            break

          case FormType.TypeFormCitogeneticaArray:
            p.patientCitogenetics.forEach((patient, i) => {
              if (i == 0) {
                if (!patient._sample?._typeSample) {
                  completed = false
                  enqueueSnackbar(t('mustCompleteTheField') + t('typeSample'), {
                    variant: 'error',
                  })
                }
              }
            })

            if (!patientProducts[0].language && !patientProducts[0]._language) {
              completed = false
              enqueueSnackbar(t('mustCompleteTheField') + t('language'), {
                variant: 'error',
              })
            }
            break

          case FormType.TypeFormNGS:
            p.patientNGS.forEach((patient, i) => {
              if (i == 0) {
                if (!patient._sample?._typeSample) {
                  completed = false
                  enqueueSnackbar(t('mustCompleteTheField') + t('typeSample'), {
                    variant: 'error',
                  })
                }
              }
            })

            if (!patientProducts[0].language && !patientProducts[0]._language) {
              completed = false
              enqueueSnackbar(t('mustCompleteTheField') + t('language'), {
                variant: 'error',
              })
            }
            break
          case FormType.TypeFormNull:
            p.patientNulls.forEach((patient, i) => {
              if (i == 0) {
                if (!patient._sample?._type) {
                  completed = false
                  enqueueSnackbar(t('mustCompleteTheField') + t('typeSample'), {
                    variant: 'error',
                  })
                }
              }
            })

            if (!patientProducts[0].language && !patientProducts[0]._language) {
              completed = false
              enqueueSnackbar(t('mustCompleteTheField') + t('language'), {
                variant: 'error',
              })
            }
            break
          default:
            if (!patientProducts[0].language && !patientProducts[0]._language) {
              completed = false
              enqueueSnackbar(t('mustCompleteTheField') + t('language'), {
                variant: 'error',
              })
            }
            break
        }
      }
    })

    !completed && props.setSaveDraftAgain(false)
    completed && handleSaveDraftAgain()
  }

  const handleSaveDraftAgain = async () => {
    setIsLoading(true)
    let arrToSend: PatientProductDTO[] = []
    let pdto = emptyPatientProductDTO()
    pdto.userID = patientProducts[0].userID ||  patientProducts[0]._userID
    pdto.product = patientProducts[0]._product
    pdto.patientNulls = patientProducts[0].patientNulls
    pdto.patientPGTs = patientProducts[0].patientPGTs
    pdto.patientNGS = patientProducts[0].patientNGS
    pdto.patientMicroVE = patientProducts[0].patientMicroVE
    pdto.patientOncology = patientProducts[0].patientOncology
    pdto.patientCitogenetics = patientProducts[0].patientCitogenetics
    pdto.patientCustoms = patientProducts[0].patientCustoms
    pdto.genes = patientProducts[0]._genes
    pdto.address = patientProducts[0]._address
    //@ts-ignore
    pdto.file = files
    pdto.step = currentStep
    pdto.language = patientProducts[0].language || patientProducts[0]._language

    let types: string[] = []

    patientProducts.forEach((pp, i) => {
      if (i > 0) {
        pp.patientNulls?.forEach((p) => {
          types.push(p._sample?._type)
        })

        pp.patientPGTs?.forEach((p) => {
          types.push(p._sample?._typeSample)
        })

        pp.patientNGS?.forEach((p) => {
          types.push(p._sample?._typeSample)
        })

        pp.patientMicroVE?.forEach((p) => {
          types.push(p._sample?._typeSample)
        })

        pp.patientOncology?.forEach((p) => {
          types.push(p._sample?._typeSample)
        })

        pp.patientCitogenetics?.forEach((p) => {
          types.push(p._sample?._typeSample)
        })
      }
    })

    //@ts-ignore
    let uniqueArray = [...new Set(types)]

    if (uniqueArray?.length > 0) {
      let objTypes = await sampleTypeService
        .getFilteredListDB(
          new Query({
            query: [new QueryParam('idsOdoo', uniqueArray)],
          })
        )
        .toPromise()

      let indication = 'También llega muestra '

      objTypes?.items?.forEach((t, i) => {
        if (i > 0) {
          indication += ', '
        }
        indication += t.nameES
      })

      pdto.indications = indication
    }
    arrToSend.push(pdto)

     for (let i=1; i < patientProducts?.length; i++) {
      let pdto = emptyPatientProductDTO()
      pdto.userID = patientProducts[i].userID || patientProducts[i]._userID
      pdto.product = patientProducts[i]._product
      pdto.patientNulls = patientProducts[i].patientNulls
      pdto.patientPGTs = patientProducts[i].patientPGTs
      pdto.patientNGS = patientProducts[i].patientNGS
      pdto.patientMicroVE = patientProducts[i].patientMicroVE
      pdto.patientOncology = patientProducts[i].patientOncology
      pdto.patientCitogenetics = patientProducts[i].patientCitogenetics
      pdto.patientCustoms = patientProducts[i].patientCustoms
      pdto.genes = patientProducts[i]._genes
      pdto.address = patientProducts[i]._address
      //@ts-ignore
      pdto.file = files
      pdto.step = currentStep
      arrToSend.push(pdto)
     }

    clientRequestService
      .sendPatientProductDraftAgain(arrToSend, props.id || '')
      .subscribe(() => {
        setIsLoading(false)
        navigate(URL_APPLICATIONS)
      })
  }

  useEffect(() => {
    if (isLoading) {
      client2RequestService.getWizardByID(props.id || '').subscribe((res: any) => {
        if (res) {
          setFiles(res[0].file)
          setAddress(res[0].address)
          setPatientProducts(res)
        }
        setIsLoading(false)
      })
    }
  }, [isLoading])

  useEffect(() => {
    if (props.id) {
      requestService.getByID(props.id || '').subscribe((res) => {
        if (res) {
          setCurrentStep(res.step)
          setRequest(res as Request)
        }
      })
    }
  }, [props])

  return (
    <Grid container spacing={2}>
      {authService.userCan(Permission.createRequestToOtherClient) && (
        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            onClick={() => setChangeClientModalOpen(true)}>
            {t('changeClient')}
          </Button>
        </Grid>
      )}
      <Grid item xs={12}>
        <Stepper activeStep={currentStep}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{t(label)}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Grid>
      {!isLoading ? (
        <>
          {currentStep === 0 && (
            <ProductAplication
              increaseStep={increaseStep}
              patientProducts={patientProducts}
              setPatientProducts={setPatientProducts}
              selectedProducts={patientProducts.length > 0 ? [patientProducts[0].product] : []}
              type={'view'}
              edit={true}
              requestID={props.id}
            />
          )}

          {currentStep === 1 && (
            <>
              <PatientAplication
                decreseStep={decreseStep}
                increaseStep={handleIncreaseStep}
                patientProducts={patientProducts}
                setPatientProducts={(a) => setPatientProducts(a)}
                type={'edit'}
                edit={true}
                clientIDDoingTheRequest={loggedUser.clinicID}
                setMatchingBlind={setBlindMatchingSelected}
                updatePanelSelection={updatePanelSelection}
                matchingBlind={blindMatchingSelected}
                panelSelections={panelSelections}
                files={files}
                handleFile={(f) => handleChangeFiles(f)}
              />
            </>
          )}

          {currentStep === 2 && (
            <>
              <SampleAplication
                decreseStep={decreseStep}
                pickUp={address}
                increaseStep={handleIncreaseStep}
                patientProducts={patientProducts}
                setPatientProducts={setPatientProducts}
                files={files}
                type={'edit'}
                request={request}
                userDoingTheRequest={loggedUser.id}
                setMatchingBlind={setBlindMatchingSelected}
                updatePanelSelection={updatePanelSelection}
                matchingBlind={blindMatchingSelected}
                panelSelections={panelSelections}
              />
            </>
          )}
        </>
      ) : (
        <LoadingSpinner className={style.loadingSpinner} />
      )}
      <Modal
        open={changeClientModalOpen}
        onClose={() => setChangeClientModalOpen(false)}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <ModalChangeClient
          requestID={props.id || ''}
          onClose={() => setChangeClientModalOpen(false)}
          onSaved={() => {
            setChangeClientModalOpen(false)
            setIsLoading(true)
          }}
        />
      </Modal>
    </Grid>
  )
}
